import { defineField } from '../fieldBuilder';

import type { RequestFieldDefinition } from '../types';

/** facility-power — registry field list (generated from legacy SummarySpecs; edit here going forward). */
export const FACILITY_POWER_FIELDS: readonly RequestFieldDefinition[] = [
  defineField(
    'facility-power',
    'facilityPower',
    0,
    'powerMainNominalLvVoltage',
    'Main nominal low voltage',
    'Main nominal low…',
  ),
  defineField(
    'facility-power',
    'facilityPower',
    1,
    'powerFacilityDescription',
    'Description',
    'Description',
  ),
  defineField(
    'facility-power',
    'facilityPower',
    2,
    'powerMainNominalAmps',
    'Main nominal amps',
    'Main nominal amps',
  ),
  defineField(
    'facility-power',
    'facilityPower',
    3,
    'powerTotalDataCenterItLoadKw',
    'Total data center IT load in kW',
    'Total data center I…',
  ),
  defineField(
    'facility-power',
    'facilityPower',
    4,
    'powerTotalAvailablePowerKw',
    'Total available power in kW',
    'Total available pow…',
  ),
  defineField(
    'facility-power',
    'facilityPower',
    5,
    'powerAnticipatedFinalMwSize',
    'Anticipated IT Load MW',
    'Anticipated IT Load MW',
  ),
  defineField(
    'facility-power',
    'largeUps',
    0,
    'powerExistingSiteProtectedByLargeKwUps',
    'Existing site protected by large kW UPS',
    'Existing site prote…',
  ),
  defineField(
    'facility-power',
    'largeUps',
    1,
    'powerLargeUpsDescription',
    'Description',
    'Description',
  ),
  defineField(
    'facility-power',
    'largeUps',
    2,
    'powerModelOfExistingUps',
    'If yes, model of existing UPS',
    'If yes, model of ex…',
  ),
  defineField(
    'facility-power',
    'largeUps',
    3,
    'powerLevelOfRedundancy',
    'Level of Redundancy',
    'Level of Redundancy',
  ),
  defineField(
    'facility-power',
    'largeUps',
    4,
    'powerRequiredRedundancyForUps',
    'Required redundancy for UPS system',
    'Required redundancy…',
  ),
  defineField(
    'facility-power',
    'largeUps',
    5,
    'powerBatteryChemistry',
    'Battery chemistry',
    'Battery chemistry',
  ),
  defineField(
    'facility-power',
    'largeUps',
    6,
    'powerBatteryRuntimeRequiredMin',
    'Battery Runtime Required',
    'Battery Runtime Req…',
  ),
  defineField(
    'facility-power',
    'largeUps',
    7,
    'powerSourceLocation',
    'Power Source location',
    'Power Source location',
  ),
  defineField(
    'facility-power',
    'largeUps',
    8,
    'powerFireSuppressionNeeds',
    'Are there fire suppression needs?',
    'Are there fire supp…',
  ),
  defineField(
    'facility-power',
    'powerDistribution',
    0,
    'powerUpsOutputVoltage',
    'UPS output voltage',
    'UPS output voltage',
  ),
  defineField(
    'facility-power',
    'powerDistribution',
    1,
    'powerDistributionVoltageToLoad',
    'IT load voltage',
    'IT load voltage',
  ),
  defineField(
    'facility-power',
    'powerDistribution',
    2,
    'powerOverheadBuswayOrUnderFloor',
    'Is a busway or under floor cabling to rack desired?',
    'Is a busway or unde…',
  ),
  defineField(
    'facility-power',
    'powerDistribution',
    3,
    'powerBuswayAmperage',
    'Busway amperage',
    'Busway amperage',
  ),
  defineField(
    'facility-power',
    'powerDistribution',
    4,
    'powerBuswayLengthFt',
    'Busway Length',
    'Busway Length',
  ),
  defineField(
    'facility-power',
    'powerDistribution',
    5,
    'powerTapOfBoxRequirements',
    'Tap Off Box Requirements',
    'Tap Off Box Require…',
  ),
  defineField(
    'facility-power',
    'additionalInformation',
    0,
    'powerAdditionalInformation',
    'Additional Power Info',
    'Notes',
  ),
];
